import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Space,
  Upload,
} from "antd";
import "./styles/activateAccount.css";
import FormItem from "antd/es/form/FormItem";
import { useCallback, useContext, useEffect, useState } from "react";
import config from "../../../config";
import {
  CheckCircleFilled,
  DeleteOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
const base_url = config.base_url;

function ClaimRewards({
  open,
  onOk,
  onCancel,
  reward,
  userData,
  changeReward,
}) {
  const [paymentMethod, setPaymentMethod] = useState(
    userData.userValidationData?.billing_method
  );
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [filesForRequest, setFilesForRequest] = useState([]);
  const [files, setFiles] = useState([]);
  const [form] = Form.useForm();
  const bankNameChanged = Form.useWatch("account_onwer_name", form);
  const countryChanged = Form.useWatch("country", form);
  const bicChanged = Form.useWatch("bic", form);
  const ibanChanged = Form.useWatch("iban", form);
  const paypalChanged = Form.useWatch("paypal_account", form);
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [currSybmol, setCurrSybmol] = useState("usd");
  const [largeFile1Error, setLargeFile1Error] = useState(false);
  const [usdRate, setUsdRate] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    fetch(base_url + "user/partner/currency/list", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: ``,
    })
      .then((res) => res.json())
      .then((res) => {
        const currency = res.filter((curr) => {
          return (
            curr.code === userData.userValidationData.currency.toUpperCase()
          );
        });

        setCurrSybmol(currency[0].symbol);
      })
      .catch((err) => {
        console.log(err);
      });

    form.setFieldsValue({
      currency: userData.userValidationData.currency,
      paymentMethod: userData.userValidationData.billing_method,
    });
    if (userData.userValidationData.billing_method === "paypal") {
      form.setFieldsValue({
        paypal_account: userData.userValidationData.paypal_account,
      });
    } else if (userData.userValidationData.billing_method === "bank") {
      form.setFieldsValue({
        account_onwer_name: userData.userValidationData.bank_owner_name,
        country: userData.userValidationData.bank_country,
        bic: userData.userValidationData.bank_bic,
        iban: userData.userValidationData.bank_iban,
      });
    } else {
    }
  }, []);

  useEffect(() => {
    if (reward !== undefined && currSybmol !== undefined) {
      fetch(base_url + "user/partner/currency/rate", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, /",
          "Content-type": "application/x-www-form-urlencoded",
          credentials: "include",
        },
        credentials: "include",
        body: `dollar_quantity=1&currency=usd`,
      })
        .then((res) => res.json())
        .then((res) => {
          if (userData.userValidationData.currency == "usd") {
            setUsdRate(reward);
            return;
          }
          setUsdRate(
            reward * res.currencies[userData.userValidationData.currency]
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [currSybmol, reward]);
  const handleSubmit = () => {
    const validationData = form.getFieldsValue();
    const formData = new FormData();

    if (validationData.paymentMethod === "paypal") {
      formData.append("invoice", validationData.file_type1.file);
      formData.append("currency", validationData.currency);
      formData.append("billing_method", validationData.paymentMethod);
      formData.append("paypal_account", validationData.paypal_account);
      fetch(base_url + "user/partner/claim/reward", {
        method: "POST",
        mode: "cors",
        headers: {
          credentials: "include",
        },
        credentials: "include",
        body: formData,
      })
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          changeReward(res);
          setSuccessSubmit(true);
          form.resetFields();
          setButtonLoading(false);
          form.setFieldsValue({
            file_type1: undefined,
          });
        })
        .catch((err) => {
          console.log(err);
          setButtonLoading(false);
          form.setFieldsValue({
            file_type1: undefined,
          });
        });
    } else if (validationData.paymentMethod === "bank") {
      formData.append("invoice", validationData.file_type1.file);
      formData.append("currency", validationData.currency);
      formData.append("billing_method", validationData.paymentMethod);
      formData.append("bank_owner_name", validationData.account_onwer_name);
      formData.append("bank_country", validationData.country);
      formData.append("bank_bic", validationData.bic);
      formData.append("bank_iban", validationData.iban);
      fetch(base_url + "user/partner/claim/reward", {
        method: "POST",
        mode: "cors",
        headers: {
          credentials: "include",
        },
        credentials: "include",
        body: formData,
      })
        .then((res) => {
          setSuccessSubmit(true);
          form.setFieldsValue({
            file_type1: undefined,
          });
          setButtonLoading(false);
          console.log(res);
        })
        .catch((err) => {
          form.setFieldsValue({
            file_type1: undefined,
          });
          setButtonLoading(false);
          console.log(err);
        });
    }
  };

  return (
    <Modal
      afterOpenChange={(e) => {
        if (e === false) {
          setSuccessSubmit(false);
        }
      }}
      footer={
        successSubmit
          ? [
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "15px",
                }}
              >
                <Button
                  className="closeButton"
                  onClick={(e) => {
                    onCancel();
                    setSuccessSubmit(false);
                  }}
                >
                  {dublicatedcontent.dublicatedText152}
                </Button>
              </div>,
            ]
          : [
              <Button
                className="cancelButton"
                onClick={(e) => {
                  onCancel();
                  setSuccessSubmit(false);
                }}
              >
                {dublicatedcontent.dublicatedText184}
              </Button>,
              <Button
                className="submitButton"
                onClick={(e) => {
                  form.submit();
                  // setSuccessSubmit(true);
                }}
              >
                {dublicatedcontent.dublicatedText185}
              </Button>,
            ]
      }
      className={successSubmit ? "successModal" : "activateYourAccountModal"}
      open={open}
      onCancel={(e) => {
        onCancel();
      }}
    >
      {successSubmit && (
        <div className="submitSuccess">
          <div className="submitSuccessContent">
            <CheckCircleFilled
              style={{
                fontSize: "24px",
                color: "#419F23",
              }}
            />
            <p
              style={{
                margin: "0",
                fontSize: "26px",
                fontWeight: "500",
              }}
            >
              {dublicatedcontent.dublicatedText186}
            </p>
          </div>
          <div className="activateYourAccountForm_firstRow">
            <p
              style={{
                fontSize: "14px ",
                fontWeight: "400",
              }}
            >
              {dublicatedcontent.dublicatedText187}
            </p>
          </div>
        </div>
      )}
      {!successSubmit && (
        <Form
          form={form}
          onFinish={handleSubmit}
          className="activateYourAccountForm"
        >
          <div
            className="
          returnimage"
          ></div>
          <div className="claimRewardTitle">
            <p className="activateYourAccountForm_title">
              {dublicatedcontent.dublicatedText124}
            </p>
            <p
              onClick={() => console.log(usdRate?.toFixed(0))}
              className="claimRewardTitleAmount"
            >
              {currSybmol}
              {usdRate?.toFixed(0)}
            </p>
          </div>
          <Divider className="divider" />
          <div
            style={{
              position: "relative",
            }}
          >
            <FormItem
              labelCol={{ span: 24 }}
              label={`1. ${dublicatedcontent.dublicatedText158} :`}
              name={"currency"}
              className="formSelect"
            >
              <Input
                style={{
                  textAlign: "center",
                  width: "107px",
                  textTransform: "uppercase",
                }}
                className="formInputDisabled"
                disabled
              />
            </FormItem>
            {/* <p className="currencyChanger">
              ${reward} &#8773; {currSybmol}
              {usdRate?.toFixed(0)}
            </p> */}
          </div>
          <div
            style={{
              position: "relative",
            }}
          >
            <FormItem
              className="formLabel"
              labelCol={{ span: 24 }}
              name="paymentMethod"
              label={`2. ${dublicatedcontent.dublicatedText159} :`}
            >
              <Radio.Group
                value={paymentMethod}
                onChange={(e) => {
                  setPaymentMethod(e.target.value);
                  if (paypalChanged) {
                    form.setFieldsValue({
                      account_onwer_name: undefined,
                      country: undefined,
                      bic: undefined,
                      iban: undefined,
                    });
                  }
                  if (
                    bankNameChanged ||
                    countryChanged ||
                    bicChanged ||
                    ibanChanged
                  ) {
                    form.setFieldsValue({
                      paypal_account: undefined,
                    });
                  }
                }}
                style={{
                  transform: "translateX(15px)",
                }}
              >
                <Space direction="vertical">
                  <Radio
                    disabled={
                      userData.userValidationData.billing_method !== "paypal"
                        ? true
                        : false
                    }
                    style={
                      paymentMethod === "paypal"
                        ? {
                            marginBottom: "100px",
                          }
                        : {}
                    }
                    value={"paypal"}
                  >
                    {dublicatedcontent.dublicatedText160}
                  </Radio>
                  <Radio
                    disabled={
                      userData.userValidationData.billing_method !== "bank"
                        ? true
                        : false
                    }
                    value={"bank"}
                  >
                    {dublicatedcontent.dublicatedText161}
                  </Radio>
                </Space>
              </Radio.Group>
            </FormItem>
            {paymentMethod === "paypal" && (
              <FormItem
                style={{
                  position: "absolute",
                  top: "65px",
                  left: "40px",
                  width: "44%",
                }}
                className="formLabel"
                labelCol={{ span: 24 }}
                name="paypal_account"
                label="Paypal Account"
                validateTrigger="onBlur"
              >
                <Input
                  style={{
                    width: "100%",
                  }}
                  disabled
                  className="formInputDisabled"
                />
              </FormItem>
            )}
            {paymentMethod === "bank" && (
              <>
                <FormItem
                  style={{
                    width: "44%",
                    transform: "translateX(40px)",
                  }}
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name="account_onwer_name"
                  label={dublicatedcontent.dublicatedText165}
                >
                  <Input disabled className="formInputDisabled" />
                </FormItem>
                <div
                  style={{
                    display: "flex",
                    width: "93%",
                    gap: "25px",
                    transform: "translateX(40px)",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name="country"
                    label={dublicatedcontent.dublicatedText167}
                    required
                  >
                    <Input disabled className="formInputDisabled" />
                  </FormItem>
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    className="formLabel"
                    labelCol={{ span: 24 }}
                    name="bic"
                    label={dublicatedcontent.dublicatedText170}
                  >
                    <Input disabled className="formInputDisabled" />
                  </FormItem>
                </div>
                <FormItem
                  style={{
                    width: "93%",
                    transform: "translateX(25px)",
                  }}
                  className="formLabel"
                  labelCol={{ span: 24 }}
                  name="iban"
                  label={dublicatedcontent.dublicatedText172}
                >
                  <Input className="formInputDisabled" disabled />
                </FormItem>
              </>
            )}
            <p style={{ margin: "0 0 0 17px", fontSize: "14px" }}>
              {dublicatedcontent.dublicatedText188}
              <a
                href="mailto:influencers@ostreon.io"
                style={{
                  color: "#0091EA",
                }}
              >
                influencers@ostreon.io
              </a>
            </p>
          </div>
          <div>
            <p
              style={{
                margin: "0",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              3. {dublicatedcontent.dublicatedText189}:
            </p>
            <div className="invoiceInfo">
              OSTREON CYBERSECURITY <br /> SAS 13T 15 rue Auguste Gervais <br />
              92130 Issy-les-Moulineaux, France
              <br /> {dublicatedcontent.dublicatedText190} :
              influencers@ostreon.io
              <br /> {dublicatedcontent.dublicatedText191} (SIREN) : 920 541 448
              <br /> {dublicatedcontent.dublicatedText192}: FR 18920541448
            </div>
            <Form.Item
              style={{
                marginLeft: "15px",
              }}
              className="formLabel"
              // labelCol={{ span: 24 }}
              name={"file_type1"}
              // label="Certificate of Incorporation (from the last 3 months)"
              required
              rules={[
                {
                  required: true,
                  message: dublicatedcontent.dublicatedText193,
                },
              ]}
            >
              <Upload
                itemRender={(originNode, file, fileList, { remove }) => {
                  return (
                    <div className="uploadListWrapper">
                      <PaperClipOutlined
                        style={{ color: "#0091EA", marginRight: "15px" }}
                      />
                      <p
                        style={{
                          color: "#0091EA",
                          position: "relative",
                          left: 0,
                          margin: "0 15px 0 0 ",
                          top: 0,
                        }}
                      >
                        {file.name}
                      </p>
                      <span>|</span>
                      <div
                        style={{
                          display: "flex",
                          margin: "0 0 0 15px ",
                          color: "#B20606",
                        }}
                        onClick={() => remove(file)}
                      >
                        <DeleteOutlined
                          style={{
                            margin: "0 5px 0 auto",
                          }}
                        />
                        <p
                          style={{
                            margin: 0,
                          }}
                        >
                          {dublicatedcontent.dublicatedText178}
                        </p>
                      </div>
                    </div>
                  );
                }}
                multiple={false}
                style={{
                  width: "150px",
                }}
                accept=".pdf, .jpg, .jpeg, .png"
                beforeUpload={(file) => {
                  const isLt5M = file.size / 1024 / 1024 <= 5;
                  setLargeFile1Error(false);
                  if (!isLt5M) {
                    //   alert("Image must smaller than 5MB!");
                    setLargeFile1Error(true);
                    return;
                  }
                  const reader = new FileReader();
                  setFiles((prev) => [...prev, file]);

                  setFilesForRequest((prev) => [
                    ...prev,
                    { fileType: "certificateOfInco", fileName: file.name },
                  ]);

                  reader.onload = (e) => {};

                  // Prevent upload
                  return false;
                }}
                onRemove={(e) => {
                  setLargeFile1Error(false);
                  form.setFieldsValue({
                    file_type1: undefined,
                  });
                  setFilesForRequest((prev) => {
                    return prev.filter((file) => {
                      return file.fileName !== e.name;
                    });
                  });
                  setFiles((prev) => {
                    return prev.filter((file) => file.name !== e.name);
                  });
                }}
              >
                <Space>
                  <Button
                    style={{
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    {dublicatedcontent.dublicatedText194}
                  </Button>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#858585",
                      margin: 0,
                    }}
                  >
                    {dublicatedcontent.dublicatedText175}
                  </p>
                </Space>
                {largeFile1Error && (
                  <p
                    style={{
                      margin: "10px 0 0 0 ",
                      color: "#FF0000",
                      fontSize: "14px",

                      fontWeight: 400,
                    }}
                  >
                    {dublicatedcontent.dublicatedText180}
                  </p>
                )}
              </Upload>
            </Form.Item>
          </div>
          <div>
            <p
              style={{
                margin: "0",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              4. {dublicatedcontent.dublicatedText195}!
            </p>
            <p
              style={{
                fontSize: "14px",
                color: "black",
                margin: "-2px 0 0 15px",
              }}
            >
              {dublicatedcontent.dublicatedText196}
            </p>
          </div>
        </Form>
      )}
    </Modal>
  );
}

export default ClaimRewards;
